import { jsx } from "react/jsx-runtime";
import { Box, Tag, IconTick } from "braid-design-system";
import { overflow } from "../../SkillsMatch/SkillsMatchSignedIn/SkillsMatchSignedIn.css.mjs";
const SkillsMatchPill = ({
  quality,
  isAdded,
  onUserAction
}) => {
  const pillLabel = quality.keyword.text;
  const tagProps = !onUserAction ? {
    icon: /* @__PURE__ */ jsx(IconTick, { data: { testid: `iconTick${pillLabel}` } }),
    state: "selected"
  } : {
    ...isAdded ? {
      icon: /* @__PURE__ */ jsx(IconTick, { data: { testid: `iconTick${pillLabel}` } }),
      clearLabel: `Remove ${pillLabel}`,
      onClear: () => onUserAction(quality),
      state: "selected"
    } : {
      addLabel: `Add ${pillLabel}`,
      onAdd: () => onUserAction(quality),
      state: "default"
    }
  };
  return /* @__PURE__ */ jsx(Box, { className: overflow, children: /* @__PURE__ */ jsx(Tag, { size: "small", ...tagProps, children: pillLabel }) });
};
export {
  SkillsMatchPill
};
